var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('h2',{staticClass:"kiu-grid-title"},[_c('span',{staticClass:"kiu-grid-title__text"},[(_vm.needsPrefix)?_c('span',{staticClass:"kiu-grid-title__prefix"},[_vm._v("Hotelgutscheine")]):_vm._e(),_vm._v(" "),_c('strong',[_vm._t("default")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }